export enum AddEditOrderBreadcrumbSteps {
  productsModelsSelection = 'products-selection',
  productsQuantities = 'quantities',
  orderDetails = 'order-details',
}
